// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/manufacturing.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcknowledgeExceptionRequest, ApprovePlannedActionRequest, Bom, CancelDemandSignalRequest, CancelPlannedActionRequest, CancelProductionOrderRequest, CommitSopPlanRequest, CommitSopPlanResponse, CompleteProductionOrderRequest, CreateBomRequest, CreateDemandSignalRequest, CreateProductionOrderRequest, CreateSupplyEdgeRequest, CreateSupplyNodeRequest, CtpRequest, CtpResponse, DemandSignal, DismissExceptionRequest, ForecastRequest, ForecastResponse, GetBomRequest, GetDemandSignalRequest, GetPlannedActionRequest, ListBomsRequest, ListBomsResponse, ListDemandSignalsRequest, ListDemandSignalsResponse, ListExceptionsRequest, ListExceptionsResponse, ListPlannedActionsRequest, ListPlannedActionsResponse, ListProductionOrdersRequest, ListProductionOrdersResponse, ListSupplyNodesRequest, ListSupplyNodesResponse, PlannedAction, PlanningException, ProductionOrder, ReleaseProductionOrderRequest, ReplanRequest, ReplanResponse, ResolveExceptionRequest, SimulateRequest, SimulateResponse, SopDemandPlanRequest, SopDemandPlanResponse, SopFinancialRequest, SopFinancialResponse, SopRccpRequest, SopRccpResponse, StartProductionOrderRequest, SupplyEdge, SupplyNode } from "./manufacturing_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.ManufacturingService
 */
export const ManufacturingService = {
  typeName: "omnios.v1.ManufacturingService",
  methods: {
    /**
     * Demand signals
     *
     * @generated from rpc omnios.v1.ManufacturingService.CreateDemandSignal
     */
    createDemandSignal: {
      name: "CreateDemandSignal",
      I: CreateDemandSignalRequest,
      O: DemandSignal,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ListDemandSignals
     */
    listDemandSignals: {
      name: "ListDemandSignals",
      I: ListDemandSignalsRequest,
      O: ListDemandSignalsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CancelDemandSignal
     */
    cancelDemandSignal: {
      name: "CancelDemandSignal",
      I: CancelDemandSignalRequest,
      O: DemandSignal,
      kind: MethodKind.Unary,
    },
    /**
     * BOMs
     *
     * @generated from rpc omnios.v1.ManufacturingService.CreateBom
     */
    createBom: {
      name: "CreateBom",
      I: CreateBomRequest,
      O: Bom,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.GetBom
     */
    getBom: {
      name: "GetBom",
      I: GetBomRequest,
      O: Bom,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ListBoms
     */
    listBoms: {
      name: "ListBoms",
      I: ListBomsRequest,
      O: ListBomsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Planning
     *
     * @generated from rpc omnios.v1.ManufacturingService.TriggerReplan
     */
    triggerReplan: {
      name: "TriggerReplan",
      I: ReplanRequest,
      O: ReplanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.GetForecast
     */
    getForecast: {
      name: "GetForecast",
      I: ForecastRequest,
      O: ForecastResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ListPlannedActions
     */
    listPlannedActions: {
      name: "ListPlannedActions",
      I: ListPlannedActionsRequest,
      O: ListPlannedActionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ApprovePlannedAction
     */
    approvePlannedAction: {
      name: "ApprovePlannedAction",
      I: ApprovePlannedActionRequest,
      O: PlannedAction,
      kind: MethodKind.Unary,
    },
    /**
     * Production orders
     *
     * @generated from rpc omnios.v1.ManufacturingService.CreateProductionOrder
     */
    createProductionOrder: {
      name: "CreateProductionOrder",
      I: CreateProductionOrderRequest,
      O: ProductionOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ReleaseProductionOrder
     */
    releaseProductionOrder: {
      name: "ReleaseProductionOrder",
      I: ReleaseProductionOrderRequest,
      O: ProductionOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.StartProductionOrder
     */
    startProductionOrder: {
      name: "StartProductionOrder",
      I: StartProductionOrderRequest,
      O: ProductionOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CompleteProductionOrder
     */
    completeProductionOrder: {
      name: "CompleteProductionOrder",
      I: CompleteProductionOrderRequest,
      O: ProductionOrder,
      kind: MethodKind.Unary,
    },
    /**
     * Simulation
     *
     * @generated from rpc omnios.v1.ManufacturingService.Simulate
     */
    simulate: {
      name: "Simulate",
      I: SimulateRequest,
      O: SimulateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CTP (Capable-to-Promise)
     *
     * @generated from rpc omnios.v1.ManufacturingService.CheckCtp
     */
    checkCtp: {
      name: "CheckCtp",
      I: CtpRequest,
      O: CtpResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Exceptions
     *
     * @generated from rpc omnios.v1.ManufacturingService.ListExceptions
     */
    listExceptions: {
      name: "ListExceptions",
      I: ListExceptionsRequest,
      O: ListExceptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.AcknowledgeException
     */
    acknowledgeException: {
      name: "AcknowledgeException",
      I: AcknowledgeExceptionRequest,
      O: PlanningException,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ResolveException
     */
    resolveException: {
      name: "ResolveException",
      I: ResolveExceptionRequest,
      O: PlanningException,
      kind: MethodKind.Unary,
    },
    /**
     * Supply network
     *
     * @generated from rpc omnios.v1.ManufacturingService.CreateSupplyNode
     */
    createSupplyNode: {
      name: "CreateSupplyNode",
      I: CreateSupplyNodeRequest,
      O: SupplyNode,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CreateSupplyEdge
     */
    createSupplyEdge: {
      name: "CreateSupplyEdge",
      I: CreateSupplyEdgeRequest,
      O: SupplyEdge,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ListSupplyNodes
     */
    listSupplyNodes: {
      name: "ListSupplyNodes",
      I: ListSupplyNodesRequest,
      O: ListSupplyNodesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * S&OP (Sales & Operations Planning)
     *
     * @generated from rpc omnios.v1.ManufacturingService.GetSopDemandPlan
     */
    getSopDemandPlan: {
      name: "GetSopDemandPlan",
      I: SopDemandPlanRequest,
      O: SopDemandPlanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CheckSopCapacity
     */
    checkSopCapacity: {
      name: "CheckSopCapacity",
      I: SopRccpRequest,
      O: SopRccpResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.GetSopFinancials
     */
    getSopFinancials: {
      name: "GetSopFinancials",
      I: SopFinancialRequest,
      O: SopFinancialResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CommitSopPlan
     */
    commitSopPlan: {
      name: "CommitSopPlan",
      I: CommitSopPlanRequest,
      O: CommitSopPlanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Additional RPCs
     *
     * @generated from rpc omnios.v1.ManufacturingService.CancelPlannedAction
     */
    cancelPlannedAction: {
      name: "CancelPlannedAction",
      I: CancelPlannedActionRequest,
      O: PlannedAction,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.ListProductionOrders
     */
    listProductionOrders: {
      name: "ListProductionOrders",
      I: ListProductionOrdersRequest,
      O: ListProductionOrdersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.CancelProductionOrder
     */
    cancelProductionOrder: {
      name: "CancelProductionOrder",
      I: CancelProductionOrderRequest,
      O: ProductionOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.DismissException
     */
    dismissException: {
      name: "DismissException",
      I: DismissExceptionRequest,
      O: PlanningException,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.GetDemandSignal
     */
    getDemandSignal: {
      name: "GetDemandSignal",
      I: GetDemandSignalRequest,
      O: DemandSignal,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ManufacturingService.GetPlannedAction
     */
    getPlannedAction: {
      name: "GetPlannedAction",
      I: GetPlannedActionRequest,
      O: PlannedAction,
      kind: MethodKind.Unary,
    },
  }
};

